// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27SfD","footer":"styles_footer__1YSSV"};